<template>
  <div class="msg" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <!-- <h3 style="margin: 0; background-color: #666; padding: 3px; color: #fff; font-weight: 600;">已排程的廣播</h3> -->
    <div class="broadcastTable">
      <el-table ref="removeID" :data="scheduleRecords" empty-text="目前無記錄" key="table2" border height="calc(100vh - 350px)" @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <!-- 排程 -->
        <el-table-column prop="type"
          :width="220"
          label="排程時間"
          sortable>
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px;">{{ scope.row ? getTime(scope.row[1].scheduleTime) : '無資料' }}</span>
          </template>
        </el-table-column>
        <!-- 廣播卡片 -->
        <el-table-column prop="type"
          label="廣播卡片">
          <template slot-scope="scope">
            <span style="font-weight: 400; font-size: 15px;">{{ (scope.row && scope.row[1].cardName) ? scope.row[1].cardName.replace('@$@', '').replace('@#@', '') : 'Unknown' }}</span>
          </template>
        </el-table-column>
        <!-- 廣播標籤 -->
        <el-table-column prop="type"
          label="廣播標籤">
          <template slot-scope="scope">
            <span style="font-weight: 400; font-size: 15px;">{{ (scope.row && scope.row[1].tag) ? scope.row[1].tag : '無' }}</span>
          </template>
        </el-table-column>
        <!-- 廣播狀態 -->
        <el-table-column prop="type"
          label="廣播標籤">
          <template slot-scope="scope">
            <el-button v-if="scope.row[1].scheduleTime > Date.now()" size="small" type="primary">待發布</el-button>
            <el-button v-else size="small" type="success">已發布</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-button type="danger" :disabled="removeID.length < 1" @click="removeCheck = true">刪除排程</el-button>
      </div>
      <mu-dialog :open="removeCheck" title="確認訊息" width="550">
        確定要刪除這則排程廣播嗎?
        <mu-button slot="actions" flat color="primary" @click="removeCheck = false">返回</mu-button>
        <mu-button slot="actions" color="primary" @click="removeSchedule">確認</mu-button>
      </mu-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  name: 'broadcastRecord',
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      pageLoading: false,
      removeID: [],
      removeCheck: false,
      scheduleRecords: []
    }
  },
  mounted() {
    this.getScheduleRecord();
  },
  methods: {
    ...mapActions({
      removeSchedules: 'removeSchedules',
      getSchedule: 'getSchedule'
    }),
    getTime(time) {
      return new Date(time).toLocaleString();
    },
    showFlassMessage(message, time) {
      this.$notify({
        title: message,
        type: 'success'
      });
    },
    getScheduleRecord() {
      this.getSchedule({ service: this.service, auth: this.auth })
        .then((res) => {
          if (res.data.List !== []) {
            this.scheduleRecords = res.data.List.sort((a, b) => a[1].scheduleTime - b[1].scheduleTime);
          }
          else {
            this.scheduleRecords = [];
          }
        })
    },
    removeSchedule() {
      this.removeCheck = false;
      this.pageLoading = true;
      const removeId = this.removeID.map(el => el[0]);
      this.removeSchedules({ service: this.service, auth: this.auth, removeId: removeId })
        .then(() => {
          this.pageLoading = false;
          this.getScheduleRecord();
          this.showFlassMessage('已刪除排程廣播', 2000);
        })
    },
    handleSelectionChange(val) {
      this.removeID = val;
    },
  },
}
</script>

<style scoped>
.msg {
  margin: 0 auto;
  background-color: #fff;
  padding: 15px;
  border-radius: 5px;
  width: 89%;
  /* min-width: 750px; */
  max-width: 850px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
}
.card {
  border-radius: 3px;
  background-color: #999;
  padding: 15px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
}
</style>